import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Gallery.css";
import { Autoplay, Navigation } from "swiper/modules";
import gallery_1 from "../../assets/galeri_kegiatan/kegiatan_1.jpg";
import gallery_2 from "../../assets/galeri_kegiatan/kegiatan_2.jpg";
import gallery_3 from "../../assets/galeri_kegiatan/kegiatan_3.jpg";
import gallery_4 from "../../assets/galeri_kegiatan/kegiatan_4.jpg";
import gallery_5 from "../../assets/galeri_kegiatan/kegiatan_5.jpg";
import gallery_6 from "../../assets/galeri_kegiatan/kegiatan_6.jpg";
import gallery_7 from "../../assets/galeri_kegiatan/kegiatan_7.jpg";
import gallery_8 from "../../assets/galeri_kegiatan/kegiatan_8.jpg";
import gallery_9 from "../../assets/galeri_kegiatan/kegiatan_9.jpg";
import gallery_10 from "../../assets/galeri_kegiatan/kegiatan_10.jpg";
import gallery_11 from "../../assets/galeri_kegiatan/kegiatan_11.jpg";
import gallery_12 from "../../assets/galeri_kegiatan/kegiatan_12.jpg";
import gallery_13 from "../../assets/galeri_kegiatan/kegiatan_13.webp"

const Gallery = () => {
  return (
    <React.Fragment>
      <div className="container-gallery">
        <h1 className="title-gallery">Galeri Kegiatan</h1>
        <Swiper
          slidesPerView={4} // default: 4 slides per view
          spaceBetween={10} // ruang antar slide
          navigation={false}
          autoplay={{
            delay: 2500, // waktu transisi antar slide dalam milidetik
            disableOnInteraction: false, // autoplay tidak berhenti saat interaksi
          }}
          loop={true}
          modules={[Navigation, Autoplay]}
          breakpoints={{
            // ketika lebar layar lebih besar dari 1200px
            1200: {
              slidesPerView: 4, // 4 slides pada layar besar
              spaceBetween: 20, // ruang antar slide
            },
            // ketika lebar layar lebih besar dari 768px
            768: {
              slidesPerView: 3, // 3 slides pada layar sedang
              spaceBetween: 15, // ruang antar slide
            },
            // ketika lebar layar lebih besar dari 480px
            480: {
              slidesPerView: 2, // 2 slides pada layar kecil
              spaceBetween: 10, // ruang antar slide
            },
            // untuk layar lebih kecil dari 480px
            0: {
              slidesPerView: 2, // 1 slide pada layar kecil banget
              spaceBetween: 10, // ruang antar slide
            },
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <img
              src={gallery_1}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_2}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_3}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_4}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_5}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_6}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_7}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_8}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_9}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_10}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_11}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_12}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={gallery_13}
              alt="Bimbel Polri Terbaik"
              className="img-gallery-kegiatan"
            />
          </SwiperSlide>
        </Swiper>

        {/* ===== */}
        <div className="container-video-tc">
          <iframe
            className="video-training-camp"
            // width="6000"
            height="400"
            src="https://www.youtube.com/embed/XKtZARuCTH0?si=9kAf9cXb0sJ98WyJ"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>

          <iframe
            className="video-training-camp"
            // width="6000"
            height="400"
            src="https://www.youtube.com/embed/g6jSRjry8mM?si=RAc65gjLWpa6hLeR"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Gallery;
